"use strict";

define('service/overlay',['appkit/service', 'underscore', 'backbone', 'appkit/changes.helper'], function (Service, _, Backbone, ChangesHelper) {
  var OverlayService = Service.extend({
    replies: {
      'show:singleModelDependentOverlay': 'showSingleModelDependentOverlay',
      'show:overlay': 'showOverlay'
    },
    showOverlay: function showOverlay(contentView) {
      var events = _.extend({}, Backbone.Events),
        app = this.app,
        overlay = app.overlay;
      _.defer(function () {
        overlay.active = true;
      });
      contentView.listenToOnce(overlay, 'hidden', function () {
        contentView.destroy();
      });
      overlay.content.show(contentView);
      return overlay;
    },
    showSingleModelDependentOverlay: function showSingleModelDependentOverlay(contentView, options) {
      var app = this.app,
        overlay = app.overlay,
        model = options.model;
      var changesHelper = new ChangesHelper().add(model),
        unsavedModalEvents = this.channel.request('modal', {
          type: 'UNSAVED_CHANGES',
          state: changesHelper
        }),
        accidentalCloseModal = this.channel.request('modal', {
          type: 'UNSAVED_CHANGES'
        });
      if (!model) {
        throw new Error('There is no available model for this overlay.');
      }
      overlay.content.show(contentView);
      if (options.editable) {
        overlay.buttonType = 'save';
        overlay.cancelable = true;
      } else {
        overlay.buttonType = 'close';
      }
      _.defer(function () {
        overlay.active = true;
      });
      contentView.listenTo(unsavedModalEvents, 'modal:show', function () {
        overlay.active = true;
      }).listenTo(unsavedModalEvents, 'save:model', function () {
        model.save();
      }).listenTo(overlay, 'save', function () {
        model.save();
      }).listenTo(model, 'invalid', function () {
        overlay.active = true;
      }).listenTo(model, 'sync', function () {
        overlay.active = false;
      }).listenToOnce(overlay, 'hidden', function () {
        changesHelper.off();
        unsavedModalEvents.stopListening();
        contentView.destroy();
      });
      contentView.listenTo(overlay, 'leaving', function () {
        if (changesHelper.get('changes') == true) {
          overlay.active = true;
          accidentalCloseModal.visible = true;
        }
      }).listenTo(accidentalCloseModal, 'approve', function () {
        model.save();
      }).listenTo(accidentalCloseModal, 'deny', function () {
        overlay.active = false;
      });
      return overlay;
    }
  });
  return OverlayService;
});

